import httpRequest from "../ajax";

const contactImportService = {
  recordConsent: async () => {
    const response = await httpRequest("post", "/contacts/consent", {});
    return response.data;
  },

  getGoogleAuthUrl: async (returnPath = "/home") => {
    const webOrigin =
      typeof window !== "undefined" ? window.location.origin : "";
    const params = new URLSearchParams({
      return_path: returnPath,
    });
    if (webOrigin) {
      params.set("web_origin", webOrigin);
    }
    const response = await httpRequest(
      "get",
      `/contacts/import/google/start?${params.toString()}`
    );
    return response.data;
  },

  reimportGoogle: async () => {
    const response = await httpRequest("post", "/contacts/import/google", {});
    return response.data;
  },

  importCsv: async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await httpRequest("post", "/contacts/import/csv", formData);
    return response.data;
  },

  getContacts: async () => {
    const response = await httpRequest("get", "/contacts");
    return response.data;
  },

  sendInvites: async (contactIds, message = {}) => {
    const payload = { contact_ids: contactIds };
    if (message.custom_subject) payload.custom_subject = message.custom_subject;
    if (message.custom_body) payload.custom_body = message.custom_body;
    if (message.custom_sms) payload.custom_sms = message.custom_sms;
    const response = await httpRequest("post", "/contacts/invite", payload);
    return response.data;
  },

  getStats: async () => {
    const response = await httpRequest("get", "/contacts/invite/stats");
    return response.data;
  },

  deleteAllContacts: async () => {
    const response = await httpRequest("delete", "/contacts");
    return response.data;
  },

  dismissNudge: async () => {
    const response = await httpRequest("post", "/contacts/nudge/dismiss", {});
    return response.data;
  },

  recordTier3Share: async () => {
    const response = await httpRequest("post", "/contacts/nudge/tier3-share", {});
    return response.data;
  },
};

export default contactImportService;
